import React from 'react'
import { Link } from 'react-router-dom'
import User from './user'
import Logo from '../../../images/logo.png'
import '../../../css/components/admin/header.css'

const Index = ({locUser}) => {
  return (
    <div className='admin_header_wrapper'>
      <div className='admin_header_container'>
        <div className='admin_header_row'>
            <div className='admin_header_logo'>
                <Link to='/'><img src={Logo} alt='Kaay'/></Link>
            </div>
            <div className='admin_header_user'>
                <User locUser = {locUser}/>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Index
